
import ClipboardJS from "clipboard";
const defaults = {
    link: "",
    subject: "",
    message: "{{link}}",
    tooltip: {
        class: "share-tooltipped",
        classPosition: "share-tooltipped-n",
        duration: 3000,
    },
    selectors: {
        btnSocialsFacebook: "[data-share-facebook]",
        btnSocialsTwitter: "[data-share-twitter]",
        btnSocialsLinkedIn: "[data-share-linkedin]",
        btnSocialsEmail: "[data-share-email]",
        btnSocialsCopy: "[data-share-copy]",
    },
};

export default class Share {
    constructor(element, options) {
        this.element = element;
        this.options = Object.assign({}, defaults, options);
    }

    run() {
        this.initialize();
        this.bindEvents();
    }

    initialize() {
        this.initializeElements();
        this.initializeLinks();
        this.initializeMessage();
        this.initializeClipboard();
    }

    initializeElements() {
        this.btnSocialsFacebook = this.element.querySelector(this.options.selectors.btnSocialsFacebook);
        this.btnSocialsTwitter = this.element.querySelector(this.options.selectors.btnSocialsTwitter);
        this.btnSocialsLinkedIn = this.element.querySelector(this.options.selectors.btnSocialsLinkedIn);
        this.btnSocialsEmail = this.element.querySelector(this.options.selectors.btnSocialsEmail);
        this.btnSocialsCopy = this.element.querySelector(this.options.selectors.btnSocialsCopy);
    }

    initializeLinks() {
        this.link = this.options.link && this.options.link.length > 0 ? this.options.link : window.location.href;
    }

    initializeMessage() {
        this.subject = this.options.subject;
        this.message = this.options.message.replace("{{link}}", this.link);
    }

    initializeClipboard() {
        if (this.btnSocialsCopy) {
            const btnSocialsCopy = this.btnSocialsCopy;
            const link = this.link;

            const clipboard = new ClipboardJS(btnSocialsCopy, {
                text: function () {
                    return link;
                },
            });

            clipboard.on("success", success.bind(this));

            function success(e) {
                addTooltipClasses.call(this, e.trigger);
                setTimeout(timeout.bind(this, e.trigger), this.options.tooltip.duration);
            }

            function timeout(el) {
                removeTooltipClasses.call(this, el);
            }

            function addTooltipClasses(el) {
                el.classList.add(this.options.tooltip.class);
                el.classList.add(this.options.tooltip.classPosition);
            }

            function removeTooltipClasses(el) {
                el.classList.remove(this.options.tooltip.class);
                el.classList.remove(this.options.tooltip.classPosition);
            }
        }
    }

    bindEvents() {
        if (this.btnSocialsFacebook) {
            this.btnSocialsFacebook.addEventListener("click", this.shareThroughFacebook.bind(this));
        }

        if (this.btnSocialsTwitter) {
            this.btnSocialsTwitter.addEventListener("click", this.shareThroughTwitter.bind(this));
        }

        if (this.btnSocialsLinkedIn) {
            this.btnSocialsLinkedIn.addEventListener("click", this.shareThroughLinkedIn.bind(this));
        }

        if (this.btnSocialsEmail) {
            this.btnSocialsEmail.addEventListener("click", this.shareThroughEmail.bind(this));
        }
    }

    shareThroughFacebook(e) {
        e.preventDefault();

        window.open(
            "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(this.link),
            "",
            "width=640,height=480"
        );
    }

    shareThroughTwitter(e) {
        e.preventDefault();

        window.open("https://twitter.com/share?url=" + encodeURIComponent(this.link), "", "width=640,height=480");
    }

    shareThroughLinkedIn(e) {
        e.preventDefault();

        window.open(
            "https://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent(this.link),
            "",
            "width=640,height=480"
        );
    }

    shareThroughEmail(e) {
        e.preventDefault();

        const message = encodeURIComponent(this.message);
        const subject = encodeURIComponent(this.subject);

        window.location.href = `mailto:?subject=${subject}&body=${message}`;
    }
}

export function bindShare() {
    [...document.querySelectorAll("[data-share]")].map((item) => {
        const options = {};

        if (typeof item.dataset !== "undefined" && typeof item.dataset.shareLink !== "undefined") {
            options.link = item.dataset.shareLink;
        }

        const share = new Share(item, options);

        share.run();
    });
}
